"use client";

import dynamic from "next/dynamic";

import type { OrbTextureName } from "@ui/components/core/Orb/Orb";
import type { CardChannel } from "./CardChannels";

const OmnichannelAgentInteractive = dynamic(
  () => import("./OmnichannelAgentInteractive").then(mod => mod.OmnichannelAgentInteractive),
  { ssr: false },
);

export function OmnichannelAgentClientLoader(props: {
  agentId: string;
  voiceId?: string | null;
  orbTexture?: OrbTextureName;
  voiceTitle: string;
  voiceDescription: string;
  voiceChannels: CardChannel[];
  chatTitle: string;
  chatDescription: string;
  chatChannels: CardChannel[];
  chatInputPlaceholder: string;
}) {
  return <OmnichannelAgentInteractive {...props} />;
}
